var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tarja-top",staticStyle:{"text-align":"right","padding-right":"80px"}},[_vm._v("Olá, "+_vm._s(_vm.formatarNome(_vm.$store.state.user.aluno_nome)))])
}
var staticRenderFns = []

export { render, staticRenderFns }